var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M339.237-33.772h408.177v294.351H339.237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m352.744 129.509-20.105-29.486h-27.224l12.562 29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m305.415 100.023 12.562 29.486h-62.131l12.562-29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m286.911 227.49-31.065-97.981h62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M332.639 100.023h-27.224l12.562 29.486h34.767z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M317.977 129.509h-62.131l12.562-29.486h37.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M255.846 129.509h62.131l-31.066 97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M317.977 129.509h34.767l-20.105-29.486h-27.224z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M268.408 100.023h37.007l12.562 29.486h-62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m317.977 129.509-31.066 97.981-31.065-97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M97.761 372.257c13.443 14.542 80.258 10.062 93.346 0s11.141-85.514 0-93.346-84.422-10.972-93.346 0c-8.925 10.973-13.443 78.804 0 93.346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m596.527 242.69-25.634-80.849h-28.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m622.16 161.841-25.633 80.849-25.634-80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "m596.527 80.859 25.633 80.849h28.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m570.893 161.708 25.634-80.849 25.633 80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M253.01 353.699v-28.433l34.629-42.986 18.091 52.979-11.465 37.397-24.638 18.014z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 45,
      lineHeight: "100%",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#009800",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-70.621 237.17q.44 2.24.64 3.16 1.04 5.16 1.64 7.44 6.56-2.04 11.2-2 1.16-3.6 1.84-6.52.56-2.24.56-2.72 0-.8-.8-.8-.44 0-6.12.84-2 .32-5 1.04-1.32.32-1.8.32-.72 0-2.16-.76m-.48-1.36q4.8-.4 13.24-1.44 1.44-.2 1.84-.36.28-.12.72-.44.48-.36.88-.36.52 0 2.56 1.4 1.44 1 1.44 1.56 0 .44-.56.88-.36.28-.68.88-.16.24-.84 2.08-.88 2.2-2.68 6.28 1.48.8 1.48 1.72 0 .48-.4.84-.36.32-.88.32-.32 0-1.6-.32-1.96-.48-4.92-.48-3.64 0-6.64 1-.08 1.44-1 1.44-1 0-1.8-1.92-.32-.76-.4-2.16-.4-5.44-1.4-8.84-.4-1.36-1.4-2.24-.2-.2-.2-.48 0-.64.64-.64 1.6 0 2.6 1.28",
    style: {
      fontSize: 40,
      fontFamily: "TPKaisho-GT01",
      InkscapeFontSpecification: "TPKaisho-GT01",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#009800",
      fillOpacity: 1
    },
    transform: "matrix(1.47576 0 0 2.4661 115.95 -571.638)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhi);
export default __webpack_public_path__ + "static/media/phi.adaf306ed07829d361bf0e1906472b4c.svg";
export { ForwardRef as ReactComponent };